import classNames from "classnames";
import LinkIcon from "assets/icons/LinkIcon";
import DeleteIcon from "assets/icons/DeleteIcon";
import { RefObject, useEffect, useRef } from "react";

import styles from "./style.module.scss";

interface ActionOptionsProps {
  show: boolean;
  onToggle: () => void;
  onCopyClick: () => void;
  onDeleteClick: () => void;
  showDeleteOption: boolean;
  callerRef: RefObject<HTMLDivElement>;
}

const ActionOptions = ({
  show,
  onToggle,
  callerRef,
  onCopyClick,
  onDeleteClick,
  showDeleteOption,
}: ActionOptionsProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = (e: any) => {
    if (
      !containerRef.current?.contains(e.target) &&
      !callerRef.current?.contains(e.target)
    ) {
      onToggle();
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    //eslint-disable-next-line
  }, [show]);

  return (
    <div ref={containerRef} className={styles.actionOptionsContainer}>
      <div className={styles.option} onClick={onCopyClick}>
        <div className={styles.optionIcon}>
          <LinkIcon />
        </div>
        <div className={styles.optionText}>Copy URL</div>
      </div>
      {showDeleteOption && (
        <div className={styles.option} onClick={onDeleteClick}>
          <div className={styles.optionIcon}>
            <DeleteIcon />
          </div>
          <div className={styles.optionText}>Delete</div>
        </div>
      )}
    </div>
  );
};

export default ActionOptions;
